"use strict";
$("body").on("touchstart touchend",function(){
    if ( jQuery("body").hasClass("pageproduct") ) {
        var nexusArr = [];
        jQuery('.tt-options-swatch.options-large li [data-tooltip]').each(function(){
            var touchSort = jQuery(this).attr("data-value");
            if ( touchSort === undefined ) { return; }
            if ( touchSort != null ) {
                nexusArr.push(touchSort);
            }
        });
        nexusArr.sort();
        jQuery('.tt-options-swatch.options-large li [data-tooltip]').each(function(i){
            var touchSortArrange = jQuery(this).attr("data-tooltip");
            if ( touchSortArrange === undefined ) { return; }
            if ( touchSortArrange != null ) {
                jQuery('.tt-options-swatch [data-value="'+nexusArr[i]+'"]').parent().css({"order":i});
            }
        });
        jQuery('.tt-options-swatch').eq(0).css({"display":"flex"});
        jQuery('.tt-swatches-container.tt-swatches-container-js').eq(0).css({"display":"block"});
    }
});